import { createFileRoute } from '@tanstack/react-router';
import TerminalAssignmentsView from '../terminal/TerminalAssignmentsView';
export const Route = createFileRoute('/terminals/assignments')({
  component: TerminalAssignmentsView,
});
